<template>
  <header class="demo-top-nav" role="banner">
    <div class="demo-top-nav__inner">
      <div class="demo-top-nav__left">
        <router-link to="/home" class="demo-top-nav__brand">
          <img
            src="@/assets/images/logo.png"
            alt="Baton"
            class="demo-top-nav__brand-logo"
          />
          <span class="demo-top-nav__brand-text">데이터 데모</span>
        </router-link>
      </div>
      <div class="demo-top-nav__account" aria-label="데모 계정">
        <div
          class="demo-top-nav__account-meta"
          title="demo.admin · ops.demo@batoncompany.kr"
        >
          <span class="demo-top-nav__account-id">demo.admin</span>
          <span class="demo-top-nav__account-email"
            >ops.demo@batoncompany.kr</span
          >
        </div>
        <i
          class="el-icon-user-solid demo-top-nav__account-icon"
          aria-hidden="true"
        />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "DemoTopNav",
};
</script>

<style lang="scss" scoped>
.demo-top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  z-index: 200;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.06);
}

.demo-top-nav__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-width: 0;
  padding: 0 24px;
  height: 56px;
  box-sizing: border-box;
}

.demo-top-nav__left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.demo-top-nav__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  max-width: 100%;
  text-decoration: none;
  color: inherit;
}

.demo-top-nav__brand-logo {
  display: block;
  flex-shrink: 0;
  height: 28px;
  width: auto;
  object-fit: contain;
}

.demo-top-nav__brand-text {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  letter-spacing: -0.02em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.demo-top-nav__account {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 1 auto;
  min-width: 0;
  max-width: min(52%, 320px);
}

.demo-top-nav__account-icon {
  flex-shrink: 0;
  font-size: 22px;
  color: #909399;
}

.demo-top-nav__account-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  min-width: 0;
  text-align: right;
}

.demo-top-nav__account-id {
  max-width: 100%;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  letter-spacing: -0.02em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.demo-top-nav__account-email {
  font-size: 12px;
  color: #909399;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 576px) {
  .demo-top-nav__inner {
    padding: 0 12px;
    gap: 8px;
  }

  .demo-top-nav__account {
    max-width: min(58%, 240px);
  }

  .demo-top-nav__account-email {
    display: none;
  }
}

@media (max-width: 380px) {
  .demo-top-nav__brand-text {
    display: none;
  }
}
</style>
